import { render, staticRenderFns } from "./AsientosLiberadosComponent.vue?vue&type=template&id=feb2c122"
import script from "./AsientosLiberadosComponent.vue?vue&type=script&lang=js"
export * from "./AsientosLiberadosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports